var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Small } from 'syf-component-library/ui/typography';
import { t } from '../../../../strings/i18n/i18n';
import theme from '../../../../theme';
import Icon from '../../../../ui/atoms/Icon';
import { spacing } from 'syf-component-library/defaultTheme';
import { Stack } from 'syf-component-library/ui/spacing';
var denimBlue = theme.colors.denimBlue;
var AttachedFileTextWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var AttachedFileTextContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: ", "px;\n"], ["\n  margin-left: ", "px;\n"])), spacing.xsmall);
var IconContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var DocumentAttachedText = function (_a) {
    var showEmptyState = _a.showEmptyState;
    return (_jsxs(AttachedFileTextWrapper, { children: [_jsx(IconContainer, { children: _jsx(Icon, { name: "farPaperclip", size: "1x", color: denimBlue }) }), _jsxs(AttachedFileTextContainer, { children: [_jsx(Small, __assign({ weight: "bold" }, { children: t('uploadDocuments.attachedFiles') })), showEmptyState && (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "small" }), _jsx(Small, { children: t('uploadDocuments.noAttachedFiles') })] }))] })] }));
};
export default DocumentAttachedText;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map